// Heartbeats must not close or unfocus the access explanation beside presence.
export function refreshPresenceView(target: HTMLElement, html: string): void {
  if (target.innerHTML === html) return;
  const template = target.ownerDocument.createElement("template");
  template.innerHTML = html;
  const previous = target.querySelector<HTMLDetailsElement>(".access-inspector");
  const next = template.content.querySelector<HTMLDetailsElement>(".access-inspector");
  const focused = previous?.contains(target.ownerDocument.activeElement) || false;
  if (previous && next && previous.innerHTML === next.innerHTML) next.replaceWith(previous);
  else if (previous?.open && next) next.open = true;
  target.replaceChildren(template.content);
  if (focused) target.querySelector<HTMLElement>(".access-inspector > summary")?.focus({ preventScroll: true });
}
